import React from 'react'

const question_list = [
    {
        title: 'Como emitir notas fiscais grátis? ',
        description: 'Assinando o Plano GRATUITO você tem direito à 5 notas fiscais totalmente Grátis para realizar vendas abaixo de R$5000,00',
        url: 'https://otimizeseunegocio.com/gestao-organizacao/como-emitir-notas-fiscais-gratis-no-easygestor-web-passo-a-passo/',
    },
    {
        title: 'Como realizar uma venda no Easygestor Web?',
        description: 'Após adquirir um plano de notas, acesse o Ponto de Vendas na lateral da tela e digite o produto que deseja vender e aperte enter, selecione o método de pagamento e confirme a venda',
    },
    {
        title: 'Como Cadastrar um Certificado Digital?',
        description: 'Após a compra ou renovação do seu  Certificado Digital, assegure que você tem um plano que permita o cadastro de um certificado, depois, clique na aba Certificado Digital à esquerda, então clique em "Cadastrar Certificado" e preencha as informações necessárias',
    },
    {
        title: 'Oque é e como obter um Certificado Digital?',
        description: 'O certificado digital é a identidade eletrônica de uma pessoa ou empresa. Ele funciona como uma carteira de identificação virtual e permite assinar documentos à distância com o mesmo valor jurídico da assinatura feita de próprio punho no papel, mas sem precisar reconhecer firma em cartório.',
        url: 'https://otimizeseunegocio.com/gestao-organizacao/certificado-digital-o-que-e-e-como-obter/'
    },
    {
        title: 'Onde posso contatar o técnico do Easygestor?',
        description: 'O Suporte Técnico serve para você tirar suas dúvidas e aprender sobre o sistema, e também para relatar possíveis problemas no sistema.' ,
        contact: 'https://api.whatsapp.com/send/?phone=5511966466526&text&app_absent=0'
    },
    {
        title: 'NF-e e NFC-e: sou obrigado emitir?',
        description: 'Para a emissão da NF-e e NFC-e, é necessário estar regulamentado junto à Receita Federal, possuir um CNPJ e adquirir um Certificado Digital – que é emitido por uma Certificadora credenciada. Após isso, é preciso seguir alguns passos, como, por exemplo, realizar o credenciamento da empresa na Secretaria da Fazenda, fazendo com que a Inscrição Estadual esteja regularizada, além do cadastro da empresa para emissão de notas fiscais, após isso você pode usar o Easygestor para emitir NF-e .',
        url: 'https://otimizeseunegocio.com/legislacao/nf-e-e-nfc-e-sou-obrigado-emitir/'
    },
    {
        title: 'Como funciona o Plano Gratuito?',
        description: 'O plano gratuito do Easygestor oferece o nosso próprio sistema disponível para a emissão de NF-e e NFC-e, com 5 notas grátis para você emitir em até um ano, com suporte de nosso time na sua primeira emissão. Com validade até o vencimento de seu certificado digital atual, e caso seu certificado seja renovado conosco, você recebe um BÔNUS de notas grátis.',
        url: ''
    },
    {
        title: 'Assinatura digital, o que é e como ter?',
        description: 'A assinatura digital é uma tecnologia utilizada para autenticar documentos digitais, tais como PDF. Ela utiliza as chaves criptográficas de um certificado digital para identificar os signatários, proteger as informações e dar garantia de veracidade. E para utilizá-la, o signatário precisa de um certificado digital. Esse certificado é a forma de comprovar a identidade eletrônica de pessoas físicas ou jurídicas. E para fazer, você pode usar vários aplicativos, como SafeID.',
        url: ''
    },
    {
        title: 'Para que serve o certificado digital? ',
        description: 'O Certificado Digital é utilizado por empresas que são obrigadas a emitir nota fiscal eletrônica (NF-e). Usadas para a autenticação/assinatura em sistemas restritos e sites, enviar, acompanhar e retificar a declaração do imposto de renda, assinar documentos, entre outras. Ou seja, é uma forma mais segura, barata e fácil de passar por cima de burocracia em compras digitais.',
        url: ''
    },
    {
        title: 'Posso cancelar meu plano?',
        description: 'Sim, para cancelar seu plano atual basta ir em Configurações no menu de navegação à sua esquerda, depois ir na aba Planos e faturas, e, se não houver faturas pendentes clicar em Cancelar Assinatura',
        url: ''
    },
    // {
    //     title: '',
    //     description: '',
    //     url: ''
    // },
]



export default question_list


// WEBPACK FOOTER //
// ./src/components/pages/help/questions.jsx